import React, { useState } from 'react';
import blogformcss from './blogform.module.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RichTextEditor from './RichTextEditor';
import { Modal } from 'react-bootstrap';
import API_URL from "../../config/api";

function BlogModal({ show, handleClose }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const uid = user?.id;
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [pic, setPic] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [filename, setFilename] = useState('');
  const [imgurl, setImgUrl] = useState('');

  const handleFileChange = (e) => {
    setPic(e.target.files[0]);
  };

  const handleRichTextChange = (content) => {
    setDescription(content);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
      if (!user) {
          toast.error("Please login first.");
          return;
      }
      if (!pic) {
          toast.error("Please upload an image.");
          return;
      }
      setIsLoading(true);
      try {
          const formData = new FormData();
          formData.append("name", name);
          formData.append("email", email);
          formData.append("title", title);
          formData.append("content", description);
          formData.append("posted_by", uid);
          formData.append("image", pic);
          const response = await fetch(`${API_URL}/blog/create_blog_post.php`,
              {
                  method: "POST",
                  body: formData
              }
          );
          const result = await response.json();
          if (!result.success) {
              throw new Error(result.message);
          }
          toast.success("Blog submitted successfully!");
          handleClose();
          setName("");
          setEmail("");
          setTitle("");
          setDescription("");
          setPic(null);

      } catch (err) {
          console.error(err);
          toast.error(err.message);
      } finally {
          setIsLoading(false);
      }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Submit a Blog</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h2 className="center">Submit a Blog:</h2>
        <div className={blogformcss.container}>
          <form id={blogformcss.myForm} onSubmit={handleSubmit}>
            <div className="form-group" style={{ width: '90%' }}>
              <label htmlFor="name">Name:</label>
              <input type="text" className="form-control" id="name" 
                value={name} onChange={(e) => setName(e.target.value)} required />
            </div>
            <div className="form-group" style={{ width: '90%' }}>
              <label htmlFor="email">Email:</label>
              <input type="email" className="form-control" id="email" 
                value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="form-group" style={{ width: '90%' }}>
              <label htmlFor="title">Title:</label>
              <input type="text" className="form-control" id="title" 
                value={title} onChange={(e) => setTitle(e.target.value)} required />
            </div>
            <div className="form-group" style={{ width: '90%' }}>
              <label htmlFor="description">Description:</label>
              <RichTextEditor onContentChange={handleRichTextChange} />
            </div>
            <div className="form-group" style={{ width: '90%', marginTop: '20px' }}>
              <label htmlFor="file">Upload Image:</label>
              <input type="file" className="form-control-file" 
                name="pic" accept="image/*" id="file" 
                onChange={handleFileChange} required />
            </div>
            <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
              {isLoading ? 'Submitting...' : 'Submit Blog'}
            </button>
          </form>
        </div>

        {error && <p className="error">{error}</p>}
        <ToastContainer position="top-center" autoClose={2000} hideProgressBar={false}
          newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      </Modal.Body>
    </Modal>
  );
}

export default BlogModal;
